import Vue from 'vue';
import App from './App.vue';
// import Endpoints from './components/common/Endpoints.vue';
import router from './router';
// import VueSocketIO from 'vue-socket.io'
import i18n from './i18n';
import VueTheMask from 'vue-the-mask';//https://vuejs-tips.github.io/vue-the-mask/
import money from 'v-money';
import Notifications from 'vue-notification';//https://www.npmjs.com/package/vue-notification
import FlashMessage from '@smartweb/vue-flash-message';
import VuetifyGoogleAutocomplete from 'vuetify-google-autocomplete';
import * as VueGoogleMaps from 'vue2-google-maps'
import Multiselect from 'vue-multiselect'
import BootstrapVue from 'bootstrap-vue'
import VueSimpleAlert from "vue-simple-alert";
import VTooltip from 'v-tooltip'
import Dropdown from 'vue-simple-search-dropdown';
import Autocomplete from '@trevoreyre/autocomplete-vue'
import '@trevoreyre/autocomplete-vue/dist/style.css'

Vue.use(VTooltip);
Vue.use(VueSimpleAlert);
Vue.use(BootstrapVue)
Vue.component('multiselect', Multiselect)
Vue.use(VuetifyGoogleAutocomplete, {
  load: {
    key: 'AIzaSyDeEsoP6jVjTpqWvbW6sj2P3FUDmqU9kCU',
    libraries: 'places',
  }
});
Vue.use(VueGoogleMaps, {
  load: {
    key: 'AIzaSyDeEsoP6jVjTpqWvbW6sj2P3FUDmqU9kCU',
    libraries: 'places',
  }
});
Vue.use(Dropdown);
Vue.use(Autocomplete);
Vue.use(FlashMessage);
Vue.use(Notifications)
Vue.use(VueTheMask)
Vue.use(money, { precision: 2 });
Vue.config.productionTip = false;
Vue.config.silent = true;

// Vue.use(new VueSocketIO({
//   debug: false,
//   connection: Endpoints.domainChat,
//   options: { 
//       path: "/api/chat/v1/",
//       transports: ['polling'],
//       secure: true,
//   }
// }));

new Vue({
  router,
  i18n,
  render: h => h(App),
  // sockets: {
  //   notification: function (data) {
  //     try {
  //       if (data.to == this.$session.get('user')._id) {
  //         if (data.type == 'message') {
  //           this.$notify({
  //             group: 'foo',
  //             type: 'warn',
  //             duration: 5000,
  //             title: 'Notificação',
  //             text: 'Uma nova mensagem foi enviada para você.'
  //           });
  //         }
  //       }
  //     } catch (error) {
  //     }
  //   }
  // }
}).$mount('#app')
